import { createSlice } from "@reduxjs/toolkit";

type IInitialState = {
  attendanceFilter: Record<string, any>;
};

const initialState: IInitialState = {
  attendanceFilter: {
    search_type: "name",
    status: "active",
  },
};

const rootSlice = createSlice({
  name: "root",
  initialState,
  reducers: {
    setAttendanceFilter: (state, action) => {
      state.attendanceFilter = {
        ...state.attendanceFilter,
        ...action.payload,
      };
    },
    resetAttendanceFilter: (state) => {
      state.attendanceFilter = initialState.attendanceFilter;
    },
  },
});

export const { setAttendanceFilter, resetAttendanceFilter } = rootSlice.actions;
export default rootSlice.reducer;
